import { SEARCH_GROUPING_ENDPOINT } from '../../../../../../../common/config/api_endpoints';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../../../../redux/epics/utils';
import { extractGroupingTableDataFromPayload } from '../../../../../../../common/components/table/utils/table_redux_payload_utils';

const SEARCH_CONTRACT_GROUPING_ACTION_TYPES = createAPILifecycleActionTypes(
  'SEARCH_CONTRACT_GROUPING_ACTION_TYPES',
);
export const searchContractGroupingAction = createAPILifecycleActions(
  SEARCH_CONTRACT_GROUPING_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_CONTRACT_GROUPING_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case SEARCH_CONTRACT_GROUPING_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          ...state.data,
          ...extractGroupingTableDataFromPayload(payload),
        },
        error: null,
      };
    case SEARCH_CONTRACT_GROUPING_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case SEARCH_CONTRACT_GROUPING_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const searchContractGroupingEpic = createAmplifyAPICallEpic({
  actionType: SEARCH_CONTRACT_GROUPING_ACTION_TYPES.BEGIN,
  api: SEARCH_GROUPING_ENDPOINT,
  successCallback: response => [searchContractGroupingAction.SUCCESS(response.body)],
  errorCallback: () => [searchContractGroupingAction.FAILURE()],
});
